// src/components/RefreshConnectionButton.js
import React, { useState } from 'react';
import { Button, Alert, Spinner } from 'react-bootstrap';
import api from '../api';
import './RefreshConnectionButton.css';

const RefreshConnectionButton = ({ platform, onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  console.log('[RefreshConnectionButton] Version: 2025-09-13'); // Debug log

  const handleRefresh = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      console.log(`[RefreshConnectionButton] Sending POST to /refresh-connection for platform: ${platform}`);
      const response = await api.post('/refresh-connection', { platform }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      console.log('[RefreshConnectionButton] Refresh response:', JSON.stringify(response.data, null, 2));

      // If backend says we need to reauthorize → redirect immediately
      if (response.data?.authUrl) {
        console.log('[RefreshConnectionButton] Redirecting to:', response.data.authUrl);
        window.location.href = response.data.authUrl;
        return;
      }

      // Otherwise, handle success message
      if (response.data?.message) {
        setSuccess(response.data.message);
        if (response.data.size === 0) {
          setError('No active listings found. Check Seller Hub or reauthorize.');
        } else {
          onRefresh(); // Trigger fetchProducts in parent
        }
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (err) {
      console.error('[RefreshConnectionButton] Error:', err);
      const errorMessage = err.response?.data?.error || err.message || 'Failed to refresh connection. Please try again.';
      setError(errorMessage);

      // If backend provided an authUrl on error, redirect to it
      if (err.response?.data?.authUrl) {
        console.log('[RefreshConnectionButton] Redirecting to:', err.response.data.authUrl);
        window.location.href = err.response.data.authUrl;
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="refresh-connection-container">
      <Button
        variant={platform === 'Shopify' ? 'primary' : 'outline-primary'}
        onClick={handleRefresh}
        disabled={loading}
        className={`refresh-connection-button ${platform.toLowerCase()}`}
        type="button"
      >
        {loading ? (
          <>
            <Spinner as="span" animation="border" size="sm" className="mr-2" />
            Refreshing...
          </>
        ) : (
          <>
            <i className="bi bi-arrow-repeat mr-2"></i>
            Refresh Connection
          </>
        )}
      </Button>
      {success && (
        <Alert
          variant="success"
          className="mt-2"
          onClose={() => setSuccess(null)}
          dismissible
        >
          {success}
        </Alert>
      )}
      {error && (
        <Alert
          variant="danger"
          className="mt-2"
          onClose={() => setError(null)}
          dismissible
        >
          {error}
          {/* If backend said "reauthorize", show reauth link too */}
          {error.toLowerCase().includes('reauthorize') && (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleRefresh(); // clicking link retries and triggers redirect
              }}
              className="alert-link ml-2"
            >
              Reauthorize
            </a>
          )}
        </Alert>
      )}
    </div>
  );
};

export default RefreshConnectionButton;
